import { reduxKey, SimpleXHREndpoint } from './constants';
import { SimpleXHRStoreSlice } from './types';

function getStateSlice(state: any): SimpleXHRStoreSlice {
  return state[reduxKey];
}

export const getIsLoading = (state, endpoint: SimpleXHREndpoint): boolean =>
  getStateSlice(state).loadingEndpoints.includes(endpoint);

export const getIsLoadingForGivePointsXHR = state =>
  getIsLoading(state, SimpleXHREndpoint.GIVE_POINTS);
export const getIsLoadingForGiveLlamaXHR = state =>
  getIsLoading(state, SimpleXHREndpoint.GIVE_LLAMA);
export const getIsLoadingForGiveBadgeXHR = state =>
  getIsLoading(state, SimpleXHREndpoint.GIVE_BADGE);
export const getIsLoadingForWithdrawPointsXHR = state =>
  getIsLoading(state, SimpleXHREndpoint.WITHDRAW_POINTS);

export const getInitGivePointsPopupXHRCallResult = state =>
  getStateSlice(state)['results'][SimpleXHREndpoint.GIVE_POINTS_POPUP];
export const getGiveLlamaXHRCallResult = state =>
  getStateSlice(state)['results'][SimpleXHREndpoint.GIVE_LLAMA];
export const getGiveBadgeXHRCallResult = state =>
  getStateSlice(state)['results'][SimpleXHREndpoint.GIVE_BADGE];

export const getInitDeviationXHRCallResult = state =>
  getStateSlice(state)['results'][SimpleXHREndpoint.INIT_DEVIATION];

export const postSellerDiscount = state =>
  getStateSlice(state)['results'][SimpleXHREndpoint.SELLER_DISCOUNT_CREATE];
